import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { updateAppImage } from 'src/app/models/placeholder';
import { LocalStorageService } from 'src/app/services/localStorage/localStorage.service';
import { localStorageKeys } from 'src/app/services/localStorage/localStorageVariables';

@Component({
  selector: 'update-app-modal',
  templateUrl: './update-app-modal.component.html',
  styleUrls: ['./update-app-modal.component.scss'],
})
export class UpdateAppModalComponent implements OnInit {
  @Input() forceUpdate: number;
  @Input() message: string;
  @Input() message2: string;
  @Input() initiateUpdate: Function;
  image: string;

  constructor(
    private translate: TranslateService,
    private modalCtrl: ModalController,
    private localStorageService: LocalStorageService
  ) {
    this.image = updateAppImage;

    if (!this.message) {
      this.translate
        .get('update_app_cmp.update_app_title')
        .subscribe((res: string) => {
          this.message = res;
        });
    }

    if (!this.message2) {
      this.translate
        .get('update_app_cmp.update_app_subtitle')
        .subscribe((res: string) => {
          this.message2 = res;
        });
    }
  }

  ngOnInit() {}
  updateApp() {
    this.initiateUpdate(this.forceUpdate);
  }
  closeModal() {
    this.localStorageService.setItem(localStorageKeys.IS_UPDATE_MODAL, true);
    this.modalCtrl.dismiss({ update: false });
  }
}
